import { createApiCall, MethodType, URI } from "../Api";
import { ResetPasswordData } from "models/resetPassword";

export const fetchResetPassword = (payload: ResetPasswordData) => {
  return createApiCall(MethodType.POST, URI.AUTH.RESETPASSWORD, payload);
};
